import { z } from 'zod';

/**
 * Kündigung gemäß § 312k BGB (Kündigungsbutton ohne Login).
 * Schlankes, eigenständiges Schema – bewusst NICHT
 * CancellationRequestSchema aus (legal)/cancellation wiederverwenden
 * (Withdrawal-Schutz, anderer Datenfluss). Felder 1:1 aus dem Prototyp
 * legal/kuendigung.html; reference + reason sind optional.
 */
export const CancellationSchema = z.object({
  name: z.string().min(1, 'Pflichtfeld').max(200),
  email: z.string().email('Ungültige E-Mail-Adresse'),
  reference: z.string().max(200).optional(),
  reason: z.string().max(2000).optional(),
});

export type CancellationInput = z.infer<typeof CancellationSchema>;
